import script from "./LazyVideo.vue?vue&type=script&setup=true&lang=ts"
export * from "./LazyVideo.vue?vue&type=script&setup=true&lang=ts"

import "./LazyVideo.vue?vue&type=style&index=0&id=7b7a5156&lang=scss"

const __exports__ = script;

export default __exports__